let _ = require('lodash');
let { monkey } = require('baobab');
let { Query } = require('catberry-uri');

module.exports = {
    queryObject (state) {
        // модифицируем url в зависимости от параметров показа статистики
        state.set(['account', 'statistic', 'computed', 'query'], monkey(
            ['account', 'statistic', 'isByBranch'],
            ['account', 'statistic', 'isTransposed'],
            (isByBranch, isTransposed) => {
                let query = new Query();
                query.values = _.omitBy({ isByBranch, isTransposed }, _.isUndefined);
                return query.toString();
            }
        ));
    }
};



// WEBPACK FOOTER //
// ./actions/computed/account/statistic.js